import React, { useState } from "react";
import PreviewFileModal from "../../components/common/Filemanager_PreviewFileModal";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getFileIcon } from "../../utils/fileIcon";

const ListCard = ({ title, files, dataLoading }) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handleFilePreview = (file) => {
    setSelectedFile(file);
    setShowPreviewModal(true);
  };

  return (
    <div className="dashboard__card feed-card">
      <div className="feed-card__header">
        <h5 className="dashboard__card__title">{title}</h5>
        {files.length > 0 && (
          <button type="button" className="btn btn-sm btn-link feed-card__all" onClick={() => navigate("/documents")}>
            See all files
          </button>
        )}
      </div>

      {dataLoading ? (
        <ul className="feed-card__list">
          {Array.from({ length: 6 }).map((_, i) => (
            <li key={i} className="feed-card__item">
              <Skeleton width={28} height={28} />
              <div className="flex-grow-1">
                <Skeleton width="80%" height={12} />
                <Skeleton width="45%" height={12} />
              </div>
            </li>
          ))}
        </ul>
      ) : files.length === 0 ? (
        <div className="feed-card__empty">
          <p className="mb-2">No documents yet.</p>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => navigate("/documents")}>
            Go to Documents
          </button>
        </div>
      ) : (
        <ul className="feed-card__list">
          {files.map((item, index) => (
            <li
              key={item.id || index}
              className="feed-card__item clickable"
              onClick={() => handleFilePreview(item)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleFilePreview(item)}
              role="button"
              tabIndex={0}
              title={item.file_name}
            >
              <img src={getFileIcon(item.file_name || "")} className="feed-card__fileicon" alt="" />
              <div className="feed-card__text">
                <div className="feed-card__name">{item.file_name}</div>
                {item.uploaded_on && <div className="feed-card__meta">{item.uploaded_on}</div>}
              </div>
            </li>
          ))}
        </ul>
      )}

      <PreviewFileModal
        show={showPreviewModal}
        handleClose={() => setShowPreviewModal(false)}
        file={selectedFile}
      />
    </div>
  );
};

export default ListCard;
